import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Box, Typography } from '@mui/material';
import SearchHome from '@foxtons/fdl/icons/SearchHome';
import { Button } from '@foxtons/fdl/components/Button/index';
import styles from '@styles/propertySearchPageStyles';

interface NoResultFoundInterface {
  handleIncreaseCommuntingTime?: () => void;
  isTravelTimeSearch?: boolean;
}

function NoResultsFound({
  isTravelTimeSearch = false,
  handleIncreaseCommuntingTime
}: NoResultFoundInterface) {
  const { asPath } = useRouter();

  const updateExpandParam = (expandValue: string) => {
    const url = new URL(asPath, process.env.NEXT_PUBLIC_URL); // Base URL is required but it won't be used

    url.searchParams.set('expand', expandValue);

    return `${url.pathname}${url.search}`;
  };

  return (
    <Box
      sx={{
        ...styles.notFoundContainer,
        ...(isTravelTimeSearch && styles.noResultFoundHeight)
      }}
    >
      <Box sx={styles.notFoundIconBox}>
        <SearchHome />
      </Box>
      <Typography variant="h3">
        Sorry, we did not find any properties
      </Typography>
      {isTravelTimeSearch ? (
        <Box sx={styles.increaseCommuntingTimeBox}>
          <Typography variant="h4">
            There are no places that fall within the commuting time of the 2
            places you provided.
          </Typography>
          <Typography variant="h4" sx={{ marginTop: '0.5rem' }}>
            Please increase the commuting time for at least one place.
          </Typography>

          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              sx={styles.increaseCommuntingTimeBtn}
              color="primary"
              variant="primary"
              onClick={() => handleIncreaseCommuntingTime?.()}
            >
              Increase commuting time
            </Button>
          </Box>
        </Box>
      ) : (
        <Typography variant="h4">
          You could try expanding your search area by{' '}
          <Link href={updateExpandParam('1')}>1 mile</Link> or{' '}
          <Link href={updateExpandParam('2')}>2 miles</Link>, for example?
        </Typography>
      )}
    </Box>
  );
}

export default NoResultsFound;
